<style lang="scss" scoped>
.campaign-image {
  display: inline-block;
  max-width: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  img {
    max-width: 100%;
  }
}
</style>
<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content container">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h2 class="modal-title" id="myModalLabel">
            Pairing Brief
          </h2>
        </div>

        <!-- Popup content -->
        <div class="modal-body" style="min-height: 400px">
          <div>
          <h3>Pairing Brief Details</h3>
          </div>
          <div>
            <h4>Instructions</h4>
            <p>
            MUST READ <br>
            (Drop us an email at huanrong@getkobe.com if you need any help) <br>
            </p>
            <p>
            Reminder:<br>
            <ol>
              <li> Both client and influencer will be mutually rated after each campaign and scores will be kept with Kobe to keep making the world a better place.</li>
              <li> Do not make your post live until approval from client.</li>
              <li> It is NON-MANDATORY for client to be giving a discount or any value added services.</li>
              <li> For any discounts or value-added services that has been extended to you - it is entirely up to the sole discretion of the client - KOBE is not commissioned, neither do we enjoy similar perks.</li>
              <li> KOBE gets you rewarded and recognized for sharing on social media, whilst at the same time provide word of mouth to businesses. Kobe isn’t a money making platform. </li>
              <li> For any appointment-based campaign, failure to turn up or cancellation will result in automatic removal of participation from campaign.</li>
            </ol>
            </p>

          </div>
 
        </div>
        <div>
         
            <element v-for="(campaignField, index) in pairingBriefModelSections[1].content" :key="index">
              <div class="form-group col-xs-12 col-sm-12" v-if="campaignField.type === 'text'">
                <label>{{ campaignField.label }}:</label>
                <div>{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</div>
              </div>

              <div class="form-group col-xs-12 col-sm-12" v-if="campaignField.type === 'textarea'">
                <label>{{ campaignField.label }}:</label>
                <div>{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</div>
              </div>

              <div class="form-group col-xs-12 col-sm-12" v-if="campaignField.type === 'select'">
                <label>{{ campaignField.label }}:</label>
                <div>{{ getDisplayValueFromSelect(campaignField.value, campaign[campaignField.name]) }}</div>
              </div>

              <element v-if="campaignField.type === 'multiple_options'">
                <div class="form-group col-xs-12">
                  <div class="form-group col-xs-12" v-for="(option, optionIndex) in campaign[campaignField.name]" :key="optionIndex">
                    <div class="form-group col-xs-12">
                      <h4>{{ campaignField.label }} {{ optionIndex + 1 }}</h4>
                    </div>
                    <element v-for="(optionField, index) in campaignField.template" :key="index">
                      <div class="form-group col-xs-12 col-sm-12" v-if="optionField.type == 'text'">
                        <label>{{ optionField.label }}</label>

                        <div>{{ campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : campaign[campaignField.name][optionIndex][optionField.name] }}</div>
                      </div>
                      <div class="form-group col-xs-12 col-sm-12" v-if="optionField.type == 'textarea'">
                        <label>{{ optionField.label }}</label>

                        <div style="white-space: pre-line">{{ campaign[campaignField.name][optionIndex][optionField.name] == '' ? '-' : campaign[campaignField.name][optionIndex][optionField.name] }}</div>
                      </div>
                      <div class="form-group col-xs-12 col-sm-12" v-if="optionField.type == 'upload'">
                        <label>{{ optionField.label }}</label>

                        <div class="col-xs-12">
                          <template v-for="image in campaign[campaignField.name][optionIndex][optionField.name]" >
                            <div v-if="image != ''" :key="image">
                              <a :href="constructImageURL(image)" target="_blank" :key="image" class="campaign-image">
                              <img style="width:100%" :src="constructImageURL(image)">
                            </a>
                            </div>                            
                          </template>
                        </div>
                      </div>
                      <div class="form-group col-xs-12 col-sm-12" v-if="optionField.type === 'select'">
                        <label>{{ optionField.label }}</label>
                        <div>{{ getDisplayValueFromSelect(optionField.value, campaign[campaignField.name][optionIndex][optionField.name]) }}</div>
                      </div>                          
                    </element>
                  </div>
                </div>
              </element>
            </element>
            <div class="form-group col-xs-12 col-sm-12">
              <label>Payout:</label> ${{rateCardData}}
            </div>         
        </div>
        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import campaignConfig from './config'
import campaignAPIs from './campaignAPIs'
import chatbox from './chatbox'
import config from '@/config'

export default {
  name: 'ViewPairingBriefDetailedModal',
  props: ['modalId', 'campaignData', 'rateCardData'],
  components: {
    chatbox
  },
  data() {
    return {
      campaign: {},
      pairingBriefModelSections: campaignConfig.pairingBriefModelSections,
      comments: [],
      commentTitle: 'Comment list',
      campaignAttribute: ''
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  methods: {
    enableComment: function() {
      return this.campaign.status === config.campaignStatus.PENDING_CLIENT_APPROVAL
    },
    sendComment: function(comment) {
      var newComment = {
        campaignAttribute: this.campaignAttribute,
        text: comment
      }
      campaignAPIs
        .createComment(this.campaign.id, newComment)
        .then(comment => {})
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    viewComments: function(fieldPath, fieldName) {
      const commentConditions = {
        campaignAttribute: fieldPath
      }
      campaignAPIs
        .getComments(this.campaign.id, commentConditions)
        .then(commentList => {
          this.comments = commentList.map(comment => {
            var isSelf = false
            if (this.currentUserRole === config.userRoles.CLIENT) {
              isSelf = comment.createdBy.role === config.userRoles.CLIENT
            } else {
              isSelf = comment.createdBy.role !== config.userRoles.CLIENT
            }
            return {
              text: comment.text,
              self: isSelf
            }
          })
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })

      this.commentTitle = fieldName
      this.campaignAttribute = fieldPath
      return false
    },
    constructImageURL: function(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName
    },
    getDisplayValueFromSelect: function(selectList, value) {
      var selectedOption = selectList.find(option => {
        return option.value === value
      })

      return selectedOption ? selectedOption.text : '-'
    }
  },
  watch: {
    campaignData: function(newCampaignData) {
      newCampaignData.angles = newCampaignData.angles.map(angle => {
        const cpAngle = Object.assign({}, angle)
        const sampleImages = angle.sample_images ? angle.sample_images : []
        if (cpAngle.sample_image) {
          sampleImages.push(cpAngle.sample_image)
        }
        delete cpAngle.sample_images
        delete cpAngle.sample_image
        cpAngle.sample_images = sampleImages
        return cpAngle
      })
      this.campaign = newCampaignData
      this.comments = []
      this.commentTitle = 'Comment list'
      this.campaignAttribute = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// ViewPairingBriefDetailedModal.vue?4d9ffd36